module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_resort-00c9009d20af5dcb1b36af839c10cf92.svg";